export const customStyleMap = {
    'HIGHLIGHT': {
        backgroundColor: '#faed27',
    }
};